import React, {Component} from 'react';
import {Link} from "react-router-dom";
import FocusPageId from "../../FocusPageId";

let i=0;
class Other extends React.Component {
    componentDidMount() {
        // window.scrollTo(0, 0);
        let element = document.getElementById(FocusPageId.selectedId.elementId);
        element.scrollIntoView(true);
        element.classList.add('mystyle');
        // element.style.paddingTop="50px"
        window.scrollTo({
            top: document.getElementById(FocusPageId.selectedId.elementId).offsetTop - 40,
            behavior: 'smooth'
        });

    }
    constructor(props) {
        super(props);

        this.positionAdject=this.positionAdject.bind()
    };

    positionAdject = () => {
        i++;
        // if(i<3){
        //     document.getElementById(FocusPageId.selectedId.elementId).style.paddingTop="0px";

        // }

    };

    render() {

        return (
            <div className="static-pages" onWheel={() => this.positionAdject()}>
                <div className="background-div">
                    <li><h3 className="inline-block-element"><b>その他</b></h3></li>
                     <div className="brElement"></div>
                    <h4  id="a"><b> KITCUT PCBはどこにありますか？</b>
                    </h4>
                    <p className='all-content-font-size'>
                        <Link to="/companyProfile">
                            <text className="faq-colored-link"> 本社</text>
                        </Link>
                        は香港にございます。但し、工場は中国にございます。
                    </p>
                    <p className='all-content-font-size'> 発注前の工場見学等のサービスは行っておりません。
                    </p>
                    <p className='all-content-font-size'> 香港オフィスでのガーバーファイルのお持ち込み、プリント基板の引き取りは承っておりませんのでご了承ください。
                    </p>

                     <div className="brElement"></div>
                    <h4  id="b"><b>対応しているブラウザの種類はなんですか？</b>
                    </h4>
                    <p className='all-content-font-size'>推奨ブラウザは以下の通りです。
                    </p>
                    <p className='all-content-font-size'> ＜推奨ブラウザ＞
                    </p>
                    <p className='all-content-font-size'> ・Internet Explorer 11.x
                    </p>
                    <p className='all-content-font-size'> ・FireFox（最新版）
                    </p>
                    <p className='all-content-font-size'> ・Safari（最新版）
                    </p>
                    <p className='all-content-font-size'> ・Google Chrome（最新版）
                    </p>
                    <p className='all-content-font-size'> 特にFireFox、GoogleChromeはデータ入稿時に速度が速いのでおすすめしております。
                    </p>
                    <p className='all-content-font-size'> 推奨環境以外でご利用いただいた場合、 本サイトのデザインと異なった表示をしたり、 一部の機能が使えない可能性がございます。
                    </p>

                     <div className="brElement"></div>
                    <h4  id="c"> <b>ページが正常に表示されてないようです。</b>
                    </h4>
                    <p className='all-content-font-size'>キットカットラボをご利用いただく際は下記のブラウザソフト、バージョンをご確認ください。
                    </p>
                    <p className='all-content-font-size'> 下記のブラウザソフトの表記より古いバージョンをお使いの場合、正しく表示されないことがございます。
                    </p>
                    <p className='all-content-font-size'> ブラウザ／Windows
                    </p>
                    <p className='all-content-font-size'> Google Chrome最新版、FireFox最新版、Internet Explorer 11以降
                    </p>
                    <p className='all-content-font-size'> ブラウザ／Mac
                    </p>
                    <p className='all-content-font-size'> Google Chrome最新版、Safari最新版、FireFox最新版
                    </p>
                    <p className='all-content-font-size'> ※JavaScript,Cookieは必須です。
                    </p>

                     <div className="brElement"></div>

                    <h4  id="d"><b> ログインしようとするとエラーになるのですが？</b>
                    </h4>
                    <p className='all-content-font-size'>キットカットラボをご利用いただく際は下記のブラウザソフト、バージョンをご確認ください。
                    </p>
                    <p className='all-content-font-size'> 下記のブラウザソフトの表記より古いバージョンをお使いの場合、正しく表示されないことがございます。
                    </p>
                    <p className='all-content-font-size'> ブラウザ／Windows
                    </p>
                    <p className='all-content-font-size'> Google Chrome最新版、FireFox最新版、Internet Explorer 11以降
                    </p>
                    <p className='all-content-font-size'> ブラウザ／Mac
                    </p>
                    <p className='all-content-font-size'> Google Chrome最新版、Safari最新版、FireFox最新版
                    </p>
                    <p className='all-content-font-size'> ※JavaScript,Cookieは必須です。
                    </p>


                     <div className="brElement"></div>
                    <h4  id="e"><b> サイトの使い方がよくわからないのですが？</b>
                    </h4>
                    <p className='all-content-font-size'>
                        <a onClick={()=>{document.getElementById("sub-title-span-resp").click()}}>
                        <text className="faq-colored-link"> サポートセンター</text>
                    </a>
                        へお気軽にご連絡ください。
                    </p>
                    <p className='all-content-font-size'> 多くのユーザーさまにお問い合わせいただくご質問は、よくあるご質問ページに解決方法を掲載しております。サイト内のフォームからお問い合わせいただく前に、「よくあるご質問」または「ご利用ガイド」ご覧ください。
                    </p>

                     <div className="brElement"></div> <div className="brElement"></div>
                    <h4  id="f"><b> キットカットラボからのメールが届きません？</b>
                    </h4>
                    <p className='all-content-font-size'>キットカットラボからのメールが届かない方は下記をご確認ください。
                    </p>
                    <p className='all-content-font-size'> １．ご登録いただいたメールアドレスが誤っている可能性がございます。
                    </p>
                    <p className='all-content-font-size'>
                        <a onClick={()=>{document.getElementById("sub-title-span-resp").click()}}>
                            <text className="faq-colored-link"> こちらより</text>
                        </a>
                        ご登録いただいたメールアドレスをご確認ください。
                    </p>

                     <div className="brElement"></div>
                    <h4  id="g"><b> キットカットラボからのメールが文字化けして読めません？</b>
                    </h4>
                    <p className='all-content-font-size'>ご使用のメールソフトの設定をご確認ください。
                    </p>
                    <p className='all-content-font-size'> 文字のエンコーディングは「Unicode(UTF-8)」に設定をお願いいたします。
                    </p>
                    <div className='col-md-10'></div>
                    <div className='col-md-2 col-12-custom'>
                        <Link to="/otherTopic">
                            <span className='font-size-20'>
                            戻る
                            </span>
                        </Link>
                    </div>
                </div>
            </div>
        );
    }
}

export default Other;




// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/LinkPages/FaqPages/Other.js